<template>
    <div v-wechat-title="title" class="form-table-h380">
        <crud-facecade-tree
            ref="template-list"
            :url="url"
            :treeCol="treeCol"
            :columns="columnList"
            :expandall="true"
            :buttons="[]"
            dialogWidth="95%"
            :parentField="parentField"
            :tableHeight="this.screenHeight - 100"
            :addButton="{ enabled: this.IsTemplateCreate, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            :stripe="false"
            @loadingSaveAsView="loadingSaveAsView"
            @removeRow="removeRow"
            @applyTemplate="applyTemplate"
            @LoadingUpdateViewthis="LoadingUpdateViewthis"
        >
            <slot slot="filter">
                <el-col :span="4" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="wardOptions" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-select">
                <el-col :span="8" class="padding-right10" style="display: flex; justify-content: space-around; line-height: 100%">
                    <span style="display: inline-block; width: 60%; word-wrap: break-word; white-space: normal; text-align: center">可用范围：</span>
                    <item-input type="radio" v-model="region_type" :options="hasRegionTypePermission"></item-input>
                </el-col>
            </slot>
        </crud-facecade-tree>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `RecordTemplate`,
    props: {},
    data() {
        return {
            title: `用药事件模板`,
            parentField: `group_name`,
            treeCol: `模板/分组名称`,
            decimalPlaces: 3,
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            isMerge: this.$route.query.isMerge,
            token: this.$route.query.token,
            desktopApplyTemplateShowEdit: this.$root.DesktopApplyTemplateShowEdit,
            applyTemplateShowGroupName: false, // 是否显示分钟姓名
            isApply: 0,
            key_event_config: [],
            dic_event_config: [],
            InfusionChannel: [],
            showspecifydate: false,
            permissions: [],
            IsTemplateCreate: false,
            group_names: [],
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            region_type: this.$root.ApplyTemplateDefaultRegionType,
            drugCodeConfig: this.$root.DrugCodeConfig,
            isShowTimeSS: this.$root.IsShowTimeSS,
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            url: {
                baseURL: `/api/AcisSystem/RecordTemplat`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadTemplates(resolve, reject)
                    })
                },
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row, `post`)
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            },
            surgeryInfo: null,
            onlySimpleWard: this.$root.OnlySimpleWard
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadgroup_name()
        this.loadDecimalPlaces()
        this.loadPermissions()
        // this.loadDicEventConfig()
        this.loadKeyEventConfig()
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_CURRENTUSER`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.$store.dispatch(`ADD_HOSPITAL_WARD`)
        this.$store.dispatch(`ADD_OPERATION_WARD`)
        this.$store.dispatch(`ADD_RECOVERY_WARD`)
        this.loadInfusionChannel()
        this.getlocalIp()
    },
    computed: {
        ...mapGetters([`ward_auth`, `hospital_ward_all`, `active_ward`, `currentUser`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && !this.surgeryId) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.issetoperatingward = true
                this.o_dic_ward_id = v
            }
        },
        regionTypeOption() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            r.push({ label: `区域`, value: 2 })
            return r
        },
        // add by xiaorui ACIS-22558
        // 日期：2021-08-16,
        // 功能：当前用户有区域按钮权限，才显示区域 按钮
        hasRegionTypePermission() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            if (_.find(this.permissions, { no: `templates_area_read` }) != undefined) {
                r.push({ label: `区域`, value: 2 })
                this.region_type = this.$root.ApplyTemplateDefaultRegionType
            } else {
                this.region_type = 1
            }
            return r
        },
        wardOptions() {
            let wards = null
            // ACIS-26427 麻烦啊，当 手术申请 source_hospital_ward_id 不为空,需要根据 来源院区过滤 手术区/复苏区
            if (this.surgeryInfo && this.surgeryInfo.source_hospital_ward_id) {
                wards = _.filter(this.ward_auth, ward => ward.groupId == this.surgeryInfo.source_hospital_ward_id)
            } else {
                wards = _.cloneDeep(this.ward_auth)
                // 是否开启单院区过滤
                if (!this.surgeryId && this.onlySimpleWard == `1`) {
                    // 从科室菜单-用药模版来的且 开启单院区过滤,根据右上角单院区来过滤
                    wards = _.filter(wards, ward => ward.groupId == this.active_ward.groupId)
                }
            }
            let r = []
            if (this.recordType == 2) {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `rw_`) == true
                })
            } else {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `ow_`) == true
                })
            }
            console.log(`***********************`)
            console.log(r)
            return r
        },
        columnList() {
            let me = this
            let edittmp = _.find(this.permissions, { no: `templates_area_edit` }) != undefined
            let deletetmp = _.find(this.permissions, { no: `templates_area_delete` }) != undefined
            let columnlist = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `group_name`,
                    label: `分组名称`,
                    isListable: false,
                    isEditable: this.applyTemplateShowGroupName,
                    isCreatable: true,
                    colspan: 5,
                    config: {
                        allowCreate: true
                    },
                    options: this.group_names,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `模板/分组名称`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `模板名称`,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 5,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `180`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 3,
                    options: this.hasRegionTypePermission,
                    default: this.region_type
                },
                // added by xiao rui ,
                // 日期：2021-08-21，
                // 说明：上面的可用范围表示编辑弹框 radio 列，下面 的表示 当前列表列，分开是因为权限控制只控制
                // 区域按钮是否显示，列表不收控制，都要显示
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    colspan: 3,
                    options: this.regionTypeOption,
                    default: this.region_type
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 5,
                    options: this.wardOptions,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    },
                    default: this.dic_ward_id ? [this.dic_ward_id] : []
                },
                {
                    type: `datetime`,
                    prop: `event_time`,
                    label: `基准时间`,
                    width: `180`,
                    isListable: false,
                    isEditable: this.showspecifydate,
                    isCreatable: false,
                    readonly: false,
                    colspan: 5,
                    config: {
                        datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                        noPadding: true,
                        editable: true
                    },
                    change: (that, { row, area }) => {
                        row.record_templates && _.forEach(row.record_templates, tmp => {
                            let refdate = row.event_time && me.$moment(row.event_time || ``)
                            tmp.reference_date = this.isShowTimeSS == `1` ? refdate.format(`YYYY/MM/DD HH:mm:ss`) : refdate.format(`YYYY/MM/DD HH:mm`)
                            let spdate = row.event_time && me.$moment(row.event_time || ``).add(tmp.time_offset || 0, `minutes`)
                            tmp.specify_date = this.isShowTimeSS == `1` ? spdate.format(`YYYY/MM/DD HH:mm:ss`) : spdate.format(`YYYY/MM/DD HH:mm`)
                            if (tmp.is_continue && tmp.time_offset_end) {
                                let spenddate = row.event_time && me.$moment(row.event_time || ``).add(tmp.time_offset_end || 0, `minutes`)
                                tmp.specify_date_end = this.isShowTimeSS == `1` ? spenddate.format(`YYYY/MM/DD HH:mm:ss`) : spenddate.format(`YYYY/MM/DD HH:mm`)
                            }
                        })
                    },
                    clearable: true
                },
                {
                    type: `select`,
                    prop: `dic_event_id`,
                    label: `偏移基准`,
                    width: `180`,
                    isListable: me.surgeryId != undefined,
                    isEditable: me.surgeryId != undefined,
                    isCreatable: me.surgeryId != undefined,
                    colspan: 4,
                    options: this.key_event_config,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `360`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        let rowbuttons = []
                        if (row.id && row.id > 0) {
                            if (me.surgeryId != undefined) {
                                rowbuttons.push({
                                    class: `is-plain`,
                                    label: `应用模板`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `applyTemplate`,
                                    permission: `default`
                                })
                            }
                            if (edittmp || row.region_type == 1) {
                                rowbuttons.push({
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateViewthis`,
                                    permission: `default`
                                })
                            }
                            if (deletetmp || row.region_type == 1) {
                                rowbuttons.push({
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `removeRow`,
                                    permission: `default`
                                })
                            }
                            return rowbuttons
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `record_templates`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `select`,
                            prop: `item_type`,
                            label: `项目类型`,
                            width: `100`,
                            isListable: true,
                            readonly: false,
                            options: [{ label: `事件`, value: -1 }].concat(this[`drug/drug_type`]),
                            change: (that, { row, area }) => {
                                this.$delete(row, `item`)
                            }
                        },
                        {
                            type: `remoteselect`,
                            prop: `item`,
                            label: `项目名称`,
                            width: `260`,
                            isListable: true,
                            readonly: false,
                            options: (that, { row }) => {
                                return q => {
                                    if (row.item_type == -1) {
                                        return this.loadDicEventConfig(q)
                                    } else if (row.item_type) {
                                        q.drugType = row.item_type
                                        // 排除掉禁用的
                                        q.ck_actived = true
                                        q.drugSourceHospitalWardId = (me.onlySimpleWard == `1` && !me.surgeryId) ? me.active_ward.groupId : 0
                                        return this.loadDrugItemList(q)
                                        // return this.myaxios.get(`/api/AcisSystem/Drug/Search`, q)
                                    } else {
                                        return []
                                    }
                                }
                            },
                            change: (that, { row, area }) => {
                                if (row.item_type > -1) {
                                    let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.item.value}`)
                                    req.then(data => {
                                        //   this.$set(row,'spec',data&&data.spec)
                                        this.$set(row, `unit`, data && data.drug_unit)
                                        this.$set(row, `speed_unit`, data && data.speed_unit)
                                        this.$set(row, `speed_dose`, data && data.speed_dose)
                                        this.$set(row, `dose`, data && data.dose)
                                        this.$set(row, `add_drug_way`, data && data.add_drug_way)
                                        this.$set(row, `is_continue`, data && data.is_continue)
                                        this.$set(row, `is_speed`, data && data.is_speed)
                                        this.$set(row, `concentration`, data && data.concentration || 0)
                                        this.$set(row, `concentration_unit`, data && data.concentration_unit)
                                        this.$set(row, `enable_concentration`, data && data.enable_concentration)
                                    })
                                } else {
                                    this.$set(row, `unit`, undefined)
                                    this.$set(row, `speed_unit`, undefined)
                                    this.$set(row, `speed_dose`, undefined)
                                    this.$set(row, `dose`, undefined)
                                    this.$set(row, `add_drug_way`, undefined)
                                    this.$set(row, `is_continue`, undefined)
                                    this.$set(row, `is_speed`, undefined)
                                    this.$set(row, `concentration`, undefined)
                                    this.$set(row, `concentration_unit`, undefined)
                                }
                            }
                        },
                        {
                            type: `integer1`,
                            prop: `time_offset`,
                            label: `开始时间(分钟)`,
                            width: `70`,
                            isListable: true,
                            readonly: false,
                            change: (that, { row, area }) => {
                                if (row.specify_date) {
                                    let refdate = row.reference_date && me.$moment(row.reference_date || ``).add(row.time_offset || 0, `minutes`)
                                    row.specify_date = this.isShowTimeSS == `1` ? refdate.format(`YYYY/MM/DD HH:mm:ss`) : refdate.format(`YYYY/MM/DD HH:mm`)
                                }
                            }
                        },
                        {
                            type: `integer1`,
                            prop: `time_offset_end`,
                            label: `结束时间(分钟)`,
                            width: `70`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                return !row.is_continue || row.item_type == -1
                            },
                            change: (that, { row, area }) => {
                                if (row.is_continue && row.reference_date) {
                                    let refdate = row.reference_date && me.$moment(row.reference_date || ``).add(row.time_offset_end || 0, `minutes`)
                                    row.specify_date_end = this.isShowTimeSS == `1` ? refdate.format(`YYYY/MM/DD HH:mm:ss`) : refdate.format(`YYYY/MM/DD HH:mm`)
                                }
                            }
                        },
                        {
                            type: `datetime`,
                            prop: `reference_date`,
                            label: `基准时间`,
                            isListable: false,
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            }
                        },
                        {
                            type: `datetime`,
                            prop: `specify_date`,
                            label: `指定开始时间`,
                            width: `180`,
                            isListable: this.showspecifydate,
                            readonly: false,
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            },
                            change: (that, { row, area }) => {
                                let dateBegin = this.$moment(row.reference_date || ``)
                                let dateEnd = this.$moment(row.specify_date || ``)
                                row.time_offset = dateEnd.diff(dateBegin, `minutes`) || 0
                            },
                            clearable: true
                        },
                        {
                            type: `datetime`,
                            prop: `specify_date_end`,
                            label: `指定结束时间`,
                            width: `180`,
                            isListable: this.showspecifydate,
                            readonly: (that, { row }) => {
                                return !row.is_continue || row.item_type == -1
                            },
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            },
                            change: (that, { row, area }) => {
                                let dateBegin = this.$moment(row.reference_date || ``)
                                let dateEnd = this.$moment(row.specify_date_end || ``)
                                row.time_offset_end = dateEnd.diff(dateBegin, `minutes`) || 0
                            },
                            clearable: true
                        },
                        {
                            type: `float`,
                            prop: `dose`,
                            label: `剂量`,
                            width: `100`,
                            isListable: true,
                            readonly: false
                        },
                        {
                            type: `select`,
                            prop: `unit`,
                            label: `单位`,
                            isListable: true,
                            width: `55`,
                            readonly: false,
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `bool`,
                            prop: `is_continue`,
                            label: `连续`,
                            isListable: true,
                            width: `45`,
                            readonly: false,
                            options: `enum_bool`,
                            change: (that, { row, area }) => {
                                if (!row.is_continue) {
                                    this.$set(row, `speed_unit`, null)
                                    this.$set(row, `speed_dose`, null)
                                    this.$set(row, `is_speed`, false)
                                    this.$set(row, `time_offset_end`, null)
                                    this.$set(row, `specify_date_end`, null)
                                }
                            }
                        },
                        {
                            type: `bool`,
                            prop: `is_speed`,
                            label: `流量`,
                            isListable: true,
                            width: `45`,
                            readonly: false,
                            options: `enum_bool`,
                            change: (that, { row, area }) => {
                                if (!row.is_speed) {
                                    this.$set(row, `speed_unit`, null)
                                    this.$set(row, `speed_dose`, null)
                                } else {
                                    this.$set(row, `speed_dose`, 0)
                                    this.$set(row, `is_continue`, true)
                                }
                            }
                        },
                        {
                            type: `float`,
                            prop: `speed_dose`,
                            label: `流速`,
                            width: `50`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                return !row.is_speed
                            },
                            default: 0
                        },
                        {
                            type: `select`,
                            prop: `speed_unit`,
                            label: `流速单位`,
                            isListable: true,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return !row.is_speed
                            },
                            options: _.filter(this[`drug/drug_unit`], { isspeed: true, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `float`,
                            prop: `concentration`,
                            label: `浓度`,
                            isListable: true,
                            decimal_places: this.decimalPlaces,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return !row.enable_concentration
                            }
                        },
                        {
                            type: `select`,
                            prop: `concentration_unit`,
                            label: `浓度单位`,
                            isListable: true,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return !row.enable_concentration
                            },
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `select`,
                            prop: `add_drug_way`,
                            label: `途径`,
                            isListable: true,
                            width: `120`,
                            readonly: false,
                            options: _.map(this[`drug/drug_way`], d => {
                                return {
                                    value: d.label,
                                    label: d.label,
                                    jianpin: d.jianpin
                                }
                            })
                        },
                        {
                            type: `select`,
                            prop: `dic_infusion_channel_id`,
                            label: `用药通道`,
                            width: `120`,
                            isListable: true,
                            readonly: false,
                            options: this.InfusionChannel
                            // default: this.InfusionChannel&&this.InfusionChannel[0]&&this.InfusionChannel[0].value
                        },
                        {
                            type: `string`,
                            prop: `remark`,
                            label: `备注`,
                            isListable: true,
                            readonly: false
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
            return columnlist
        }
    },
    methods: {
        loadgroup_name() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`api/AcisSystem/RecordTemplate/GetGroupNames`)
                req.then(data => {
                    if (data) {
                        this.group_names = data
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadDecimalPlaces() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ConcentrationDecimalPoint`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.decimalPlaces = parseInt(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getlocalIp() {
            return new Promise(resolve => {
                let req = this.myaxios.post(`/api/Anonymous/InternalServer/GetMyIp`)
                req.then(data1 => {
                    console.log(data1)
                    let req1 = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${data1}`)
                    req1.then((data) => {
                        console.log(`WorkstationConfig`)
                        console.log(data)
                        if (data) {
                            let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data.dic_operating_room_id || 0}`)
                            req1.then((d) => {
                                data = {
                                    dic_recovery_ward_id: d && d.dic_operating_ward_id || data.dic_recovery_ward_id,
                                    dic_operating_room_id: data.dic_operating_room_id,
                                    token: data.token,
                                    id: data.id,
                                    work_station_type: data.dic_operating_room_id ? 1 : 2
                                }

                                // 麻醉单里面则赋值且 非第三方院区，如果有手术来源，这里手术区赋本院区的手术区不合理
                                let r = typeof winformMsg
                                if (r != `undefined` && this.surgeryInfo.source_hospital_ward_id == null) {
                                    this.dic_ward_id = data.work_station_type == 1 ? `ow_${data.dic_recovery_ward_id}` : `rw_${data.dic_recovery_ward_id}`
                                }
                            }).catch(e => {
                                console.log(e)
                            })
                        }
                    })
                    resolve(data1)
                })
            })
        },
        loadSurgeryInfo(surgeryId) {
            return new Promise(resolve => {
                if (surgeryId > 0) {
                    let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${surgeryId}`)
                    req.then(surgery => {
                        this.surgeryInfo = surgery
                        resolve(surgery)
                    })
                } else {
                    resolve(null)
                }
            })
        },
        loadDrugItemList(q) {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Drug/SearchDrugModel?surgeryid=${this.surgeryId || 0}`, q)
                req.then(data => {
                    data = _.map(data, d => {
                        var codeArray = that.drugCodeConfig.split(`|`)
                        let codes = []
                        if (codeArray.length > 0) {
                            for (let item of codeArray) {
                                if (item === `0`) codes.push(d.code || `--`)
                                if (item === `1`) codes.push(d.spec || `--`)
                                if (item === `2`) codes.push(d.price || `--`)
                                if (item === `3`) codes.push(d.drug_unit || `--`)
                                if (item === `4`) codes.push(d.drug_type_names || `--`)
                                if (item === `5`) codes.push(d.firm || `--`)
                                if (item === `6`) codes.push(d.is_medicine ? `医保` : `非医保`)
                                if (item === `7`) codes.push(`库存:${d.inventory || `--`}`)
                                if (item === `8`) codes.push(d.his_id || `--`)
                            }
                        } else {
                            codes.push(d.code)
                            codes.push(d.spec || `--`)
                            codes.push(d.drug_unit || `--`)
                            codes.push(d.price || `--`)
                            codes.push(d.firm || `--`)
                        }
                        return {
                            value: d.id,
                            label: d.name,
                            abbr: d.abbr,
                            code: codes.join(`|`)
                        }
                    })
                    resolve(data)
                })
            })
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
                this.IsTemplateCreate = _.find(data, { no: `templates_create` }) != undefined
            }).catch(e => {
                console.log(e)
            })
        },
        loadKeyEventConfig() {
            if (!this.surgeryId) return
            return new Promise((resolve, reject) => {
                let recodetype = this.recordType
                if (this.isMerge == `True`) {
                    recodetype = 2
                }
                let req = this.myaxios.get(`/api/AcisSystem/KeyEventConfig/Configs`, { surgeryInfoId: this.surgeryId, recordType: recodetype })
                req.then(data => {
                    this.key_event_config =
                        data &&
                        _.orderBy(
                            _.filter(data, d => {
                                return d.evt && !d.evt.is_deleted
                            }),
                            `display_order`
                        ).map(d => {
                            return {
                                value: d.evt.id,
                                label: d.evt.name
                            }
                        })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadDicEventConfig(q) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/SearchEvent`, q)
                req.then(data => {
                    data = data && _.filter(data, x => !x.disabled)
                    this.dic_event_config =
                        data &&
                        data.map(d => {
                            return {
                                value: d.value,
                                label: d.label,
                                jianpin: d.jianpin,
                                display_order: d.display_order
                            }
                        })
                    resolve(this.dic_event_config)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadInfusionChannel() {
            let req = this.myaxios.get(`/api/AcisSystem/InfusionChannel/Get`)
            req.then(data => {
                this.InfusionChannel =
                    data &&
                    data.map(d => {
                        return {
                            value: d.id,
                            label: d.name
                        }
                    })
            }).catch(e => {
                console.log(e)
            })
        },
        loadTemplates(resolve, reject) {
            let that = this

            // 加载可用模板
            let templates = []
            var searchResult = []
            let hospitalwardid = 0
            if (that.onlySimpleWard == `1` && !that.surgeryId) {
                hospitalwardid = that.active_ward.groupId
            }

            that.loadSurgeryInfo(that.surgeryId).then(surgeryInfo => {
                if (surgeryInfo && surgeryInfo.source_hospital_ward_id) {
                    hospitalwardid = surgeryInfo.source_hospital_ward_id
                }
                hospitalwardid = this.region_type == 1 ? 0 : hospitalwardid
                let req = that.myaxios.get(`/api/AcisSystem/RecordTemplate/Templates?recordType=${this.recordType}&hospital_ward_id=${hospitalwardid}`)
                req.then((data) => {
                    let groupId = _.groupBy(data, `id`)
                    _.forEach(groupId, g => {
                        let r = { ...g[0] }
                        r.dic_ward_ids =
                            (!r.owner &&
                                g.map(d => {
                                    return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`)
                                })) ||
                            ``
                        r.region_type = r.owner ? 1 : 2
                        if (that.dic_ward_id) {
                            if (_.includes(r.dic_ward_ids, that.dic_ward_id) || r.region_type == 1) {
                                searchResult.push(r)
                            }
                        } else {
                            searchResult.push(r)
                        }
                    }
                    )
                    if (this.region_type) {
                        searchResult = _.filter(searchResult, function(c) {
                            return c.region_type == that.region_type
                        })
                    }
                    templates = this.loadgrouprows(searchResult)
                    this.loadgroup_name()
                    resolve(templates)
                }).catch(e => reject(e))
            })
        },
        loadgrouprows(searchResult) {
            let templates = []
            let groups = _.groupBy(searchResult, `group_name`)
            let groupid = 0
            _.forEach(groups, (value, key) => {
                groupid = groupid - 1
                let grouprow = {
                    id: groupid,
                    group_name: key,
                    name: key,
                    class_name: `groupClass`,
                    children: []
                }
                if (!key || key == `null`) {
                    grouprow.id = -999999
                    grouprow.group_name = `未分组`
                    grouprow.name = `未分组`
                }
                grouprow.children = value
                templates.push(grouprow)
            })
            templates = templates.sort((a, b) => b.id - a.id)
            console.log(`templates`)
            console.log(templates)
            return templates
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/RecordTemplate/Get/${row.id}`)
                req.then(data => {
                    let dd = { ...row }
                    dd.record_templates =
                        data.event_record_templates.map(d => {
                            let r = { ...d }
                            Object.assign(r, {
                                item_type: -1,
                                item: { value: d.dic_event_id, label: r.dic_event_name },
                                remark: d.remark
                            })
                            return r
                        }) || []
                    dd.record_templates = dd.record_templates.concat(
                        data.drug_record_templates.map(d => {
                            let r = { ...d }
                            Object.assign(r, {
                                item_type: d.dic_drug_type_id,
                                item: { value: d.dic_drug_id, label: r.drug_name, jianpin: r.abbr }
                            })
                            return r
                        }) || []
                    )
                    resolve(dd)
                }).catch(e => reject(e))
            })
        },
        saveOne(row, type) {
            let data = { ...row }
            let vld = _.findIndex(data.record_templates, d => {
                return d.item == undefined || d.item_type.length == 0
            })
            data.drug_record_templates = _.filter(data.record_templates, d => d.item_type > -1).map(d => {
                d.dic_drug_type_id = d.item_type
                d.dic_drug_id = d.item.value
                return d
            })
            let vld2 = _.findIndex(data.drug_record_templates, d => {
                return ((d.time_offset == undefined || d.time_offset.length == 0) && d.specify_date == null)
            })

            let vld3 = _.findIndex(data.drug_record_templates, d => {
                return d.is_continue && d.time_offset > 0 && d.time_offset_end > 0 && (parseInt(d.time_offset) > parseInt(d.time_offset_end))
            })

            let vld4 = _.findIndex(data.drug_record_templates, d => {
                return d.is_continue && !!d.specify_date && !!d.specify_date_end && (d.specify_date > d.specify_date_end)
            })

            data.event_record_templates = _.filter(data.record_templates, d => d.item_type == -1).map((d, index) => {
                return {
                    dic_event_id: d.item.value,
                    dic_event_name: d.item.label,
                    display_order: index + 1,
                    remark: d.remark,
                    specify_date: d.specify_date,
                    time_offset: d.time_offset
                }
            })
            data.regions =
                row.region_type == 1
                    ? [{ owner: this.currentUser.username }]
                    : row.dic_ward_ids ? row.dic_ward_ids.map(d => {
                        return {
                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    }) : null
            data.enum_record_type = this.recordType
            return new Promise((resolve, reject) => {
                if (data.region_type == 2 && (!data.dic_ward_ids || data.dic_ward_ids.length == 0)) {
                    this.$message.warning(`请选择可用区域`)
                    reject()
                    return
                }
                if (vld > -1) {
                    this.$message.warning(`项目或者项目类型不能为空`)
                    reject()
                    return
                }
                if (vld2 > -1) {
                    this.$message.warning(`开始时间或者指定时间不能为空`)
                    reject()
                    return
                }
                if (vld3 > -1) {
                    this.$message.warning(`结束时间不能早于开始时间`)
                    reject()
                    return
                }
                if (vld4 > -1) {
                    this.$message.warning(`指定结束时间不能早于指定开始时间`)
                    reject()
                    return
                }
                // 如果isApply=true,则通知desktop应用当前页面数据到麻醉单
                if (this.isApply == 1) {
                    let req = this.myaxios.post(`/api/AcisSystem/RecordTemplate/CheckApplyBefore?surgeryId=${this.surgeryId}&recordType=${this.recordType}`, data)
                    req.then(msg => {
                        if (msg && msg != ``) {
                            this.$confirm(msg, `提示`, {
                                confirmButtonText: `确定`,
                                cancelButtonText: `取消`,
                                type: `warning`,
                                closeOnClickModal: false
                            }).then(() => {
                                let r = typeof winformMsg
                                if (r != `undefined`) {
                                    var cefJson = { action: `ok`, data: { editApply: true, id: row.id, data: data } }
                                    winformMsg.acceptMessage(cefJson)
                                    // this.$message.success(`模板应用成功`)
                                }
                                resolve(data)
                            }).catch(() => { })
                        } else {
                            let r = typeof winformMsg
                            if (r != `undefined`) {
                                var cefJson = { action: `ok`, data: { editApply: true, id: row.id, data: data } }
                                winformMsg.acceptMessage(cefJson)
                                // this.$message.success(`模板应用成功`)
                            }
                            resolve(data)
                        }
                    }).catch(e => reject(e))
                } else {
                    // 保存模板
                    let req = this.myaxios[type](`/api/AcisSystem/RecordTemplate/${type}`, data)
                    req.then(data => {
                        resolve(data)
                        this.$message.success(`保存成功`)
                    }).catch(e => reject(e))
                }
            })
        },
        removeRow({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/RecordTemplate/Delete/${row.id}`)
                req.then(() => {
                    that.$refs[`template-list`].ReloadListData()
                }).catch(e => console.log(e))
            })
            // console.log(row,index)
        },
        ReloadListData() {
            let that = this
            that.$refs[`template-list`].ReloadListData()
        },
        loadingSaveAsView({ row }) {
            this.loadOne(row)
                .then(data => {
                    let r = { ...data }
                    this.saveas.dialogFormVisible = true
                    r.name = ``
                    r.id = 0
                    this.saveas.data = r
                })
                .catch(e => {
                    console.log(e)
                })
        },
        saveAsSuccess() {
            this.ReloadListData()
        },
        applyTemplate({ row }) {
            // 如果开启参数，应用模板打开编辑框
            if (this.desktopApplyTemplateShowEdit == 1) {
                this.isApply = 1
                this.applyTemplateShowGroupName = false
                this.showspecifydate = true
                this.$refs[`template-list`].LoadingUpdateView({ row: row, index: 1 })
            } else {
                this.showspecifydate = false
                let r = typeof winformMsg
                if (r != `undefined`) {
                    var cefJson = { action: `ok`, data: { id: row.id } }
                    winformMsg.acceptMessage(cefJson)
                // this.$message.success(`模板应用成功`)
                }
            }
        },
        LoadingUpdateViewthis({ row }) {
            this.showspecifydate = false
            this.isApply = 0
            this.applyTemplateShowGroupName = true
            this.$refs[`template-list`].LoadingUpdateView({ row: row, index: 1 })
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        },
        region_type: function() {
            this.ReloadListData()
        },
        $route: function(newUrl, oldUrl) {
            this.recordType = newUrl.query.record_type
            this.dic_ward_id = undefined
            this.loadKeyEventConfig()
            this.ReloadListData()
        },
        recordType: function() {
            this.loadKeyEventConfig()
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/RecordTemplate.vue